import './chanler2/style';
import FormStructure from './chanler2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js